import React from 'react';
import { Route } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import GESContainer from './GES';

export const GESModule = () => (
  <Route exact path={APP_ROUTES.GES_MODULE.PATH} component={GESContainer} />
);